import React from 'react';
import { withTranslation } from 'react-i18next';
import RoleForm from '../RoleForm';

const NewRolePage = (props) => {
  const form = {
    name: '',
    description: '',
    checked: [],
  };
  return (
    <RoleForm
      isCreate
      initialValues={form}
      onSubmit={(values) => props.onCreateRole(values)}
      {...props}
    />
  );
};

export default withTranslation('app')(NewRolePage);
